import client from "../request"

const create = (id, data) => {
  return client.post(`/pamms/${id}/subscribe`, data)
}

export default {
  create
}
